import styled from 'styled-components'

// Using a simple default theme for preview
const BASIC = 'basic'

const Style = {
	Wrapper: styled.div`
		position: relative;
		height: 100vh;
		display: flex;
		flex-direction: column;
		background-color: ${({$themeType, theme}) =>
			$themeType === BASIC ? '#ffffff' : '#1a202c'};
		overflow: hidden;
		color: ${({$themeType, theme}) =>
			$themeType === BASIC ? '#000000' : '#ffffff'};
	`,

	BackIcon: styled.span`
		color: ${({$themeType, theme}) =>
			$themeType === BASIC ? '#000000' : '#ffffff'};
		font-size: 32px;
		font-weight: bold;
		cursor: pointer;
		display: flex;
		align-items: center;
		justify-content: center;
		width: 40px;
		height: 40px;
		border-radius: 50%;
		transition: all 0.2s ease;
		z-index: 3;

		&:hover {
			background-color: ${({$themeType, theme}) =>
				$themeType === BASIC ? '#000000' : '#ffffff'};
			color: ${({$themeType, theme}) =>
				$themeType === BASIC ? '#ffffff' : '#000000'};
		}
	`,

	PauseCover: styled.div`
		position: fixed;
		left: 0;
		bottom: 0;
		display: flex;
		justify-content: center;
		align-items: center;
		background-color: #00000088;
		width: 100%;
		z-index: 2;
		height: ${({$isBreak}) => ($isBreak ? '87vh' : '88vh')};

		@media (max-width: 1280px) {
			height: ${({$isBreak}) => ($isBreak ? '87vh' : '92vh')};
		}

		& > p {
			line-height: 0.9;
			font-size: 200px; /* Adjusted size */
			padding: 76px 118px 100px 118px;
			border-radius: 9999px;
			color: red;
			background-color: #ffffff88;
			border: 12px solid red;

			@media (max-width: 1280px) {
				font-size: 150px;
				padding: 76px 118px 76px 118px;
			}
		}
	`,

	TitleDiv: styled.div`
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 0 40px;
		gap: 20px;
		background-color: ${({$themeType, theme}) =>
			$themeType === BASIC ? '#ffffff' : 'none'};
		border-bottom: 2px solid
			${({$themeType, theme}) => ($themeType === BASIC ? '#000000' : '#ffffff')};
		height: 12%;
		z-index: 1;

		& > h2 {
			color: ${({$themeType, theme}) =>
				$themeType === BASIC ? '#000000' : '#ffffff'};
			font-weight: bold;
			font-size: 65px;
			flex: 1;
			text-align: center;
			overflow: hidden;
			white-space: nowrap;
			text-overflow: ellipsis;
		}

		& > button {
			display: flex;
			justify-content: center;
			flex-shrink: 0;
			width: 40px;
			background: none;
			border: none;
			cursor: pointer;
		}

		@media (max-width: 1280px) {
			height: 8%;
			& > h2 {
				font-size: 40px;
			}
		}
	`,
	BreakTitleDiv: styled.div`
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 0 40px;
		gap: 20px;
		background-color: ${({$themeType, theme}) =>
			$themeType === BASIC ? '#ffffff' : '#1a202c'};
		border-bottom: 2px solid
			${({$themeType, theme}) => ($themeType === BASIC ? '#000000' : '#ffffff')};
		height: 12%;
		z-index: 1;

		& > button {
			display: flex;
			justify-content: center;
			flex-shrink: 0;
			width: 40px;
			background: none;
			border: none;
			cursor: pointer;
		}
	`,

	BreakTitleContainer: styled.div`
		display: flex;
		justify-content: center;
		align-items: center;
		flex-wrap: wrap;
		row-gap: 8px;
		column-gap: 16px;

		@media (max-width: 1280px) {
			flex-direction: column;
			gap: 8px;
		}
	`,

	BreakTitle: styled.div`
		display: flex;
		width: fit-content;
		align-items: center;
		gap: 16px;

		@media (max-width: 1280px) {
			justify-content: center;
		}

		& > h2 {
			font-weight: bold;
			font-size: 30px;
			line-height: 1;
			color: ${({$themeType, theme}) =>
				$themeType === BASIC ? '#000000' : '#ffffff'};
			text-transform: uppercase;
			position: relative;
			white-space: nowrap;

			@media (max-width: 1280px) {
				font-size: 25px;
			}
		}

		& > p {
			display: flex;
			align-items: center;
			justify-content: center;
			border: 2px solid
				${({$themeType, theme}) =>
					$themeType === BASIC ? '#4FD1C5' : '#ffffff'};
			border-radius: 30px;
			width: 150px;
			height: 43px;
			white-space: nowrap;

			@media (max-width: 1280px) {
				width: 120px;
				height: 40px;
				font-size: 24px;
			}

			& > span {
				font-weight: bold;
				font-size: 30px;
				color: ${({$themeType, theme}) =>
					$themeType === BASIC ? '#4FD1C5' : '#ffffff'};
				line-height: 1;
				position: relative;
				bottom: 3px;

				@media (max-width: 1280px) {
					font-size: 25px;
				}
			}
		}
	`,

	BreakSubTitle: styled.div`
		display: flex;
		align-items: center;
		width: fit-content;
		gap: 16px;

		@media (max-width: 1280px) {
			justify-content: center;
		}

		& > h2 {
			font-weight: bold;
			font-size: 30px;
			color: ${({$themeType, theme}) =>
				$themeType === BASIC ? '#000000' : '#ffffff'};
			line-height: 1;
			text-transform: uppercase;
			position: relative;
			white-space: nowrap;
			@media (max-width: 1280px) {
				font-size: 25px;
			}
		}
	`,

	ThemeBg: styled.div`
		position: absolute;
		width: 100%;
		height: 100%;
		background-color: #0d0b0b10;
		backdrop-filter: blur(195.502px);
	`,

	// Gradient circles placeholders if needed
	Circle1: styled.div``,
	Circle2: styled.div``,
	Circle3: styled.div``,
	Circle4: styled.div``,

	ContentDiv: styled.div`
		z-index: 1;
		display: flex;
		flex-direction: column;
		flex-grow: 1;
		height: 76%;
		overflow: hidden;

		@media (max-width: 1280px) {
			height: 63%;
		}
	`,

	FooterDiv: styled.div`
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding-left: 80px;
		padding-right: 52px;
		border-top: 2px solid
			${({$themeType, theme}) => ($themeType === BASIC ? '#000000' : '#ffffff')};
		z-index: 1;
		height: 12%;

		@media (max-width: 1280px) {
			height: 10%;
			min-height: 10%;
			padding: 0;
			justify-content: center;
			gap: 49px;
		}
	`,
	FooterInfo: styled.div`
		width: fit-content;
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 16px;

		& > h2 {
			font-weight: bold;
			font-size: 28px;
			line-height: 0.8;
			color: ${({$themeType, theme}) =>
				$themeType === BASIC ? '#000000' : '#ffffff'};
		}

		& > p {
			font-weight: bold;
			font-size: 46px;
			line-height: 0.8;
			color: ${({$themeType, theme}) =>
				$themeType === BASIC ? '#000000' : '#ffffff'};
		}

		@media (max-width: 1280px) {
			gap: 10px;

			& > h2 {
				font-family: 'Pretendard';
				font-size: 20px;
				height: 20px;
				line-height: 1;
				font-weight: 700;
			}

			& > p {
				font-family: 'Pretendard';
				font-size: 40px;
				height: 36px;
				line-height: 1;
				font-weight: 800;
			}
		}
	`,
	LogoDiv: styled.div`
		width: fit-content;
		display: flex;
		justify-content: center;
		align-items: center;
		gap: 16px;

		& > img {
			width: ${({$logoWidth}) => $logoWidth || 200}px;
			height: ${({$logoHeight}) => $logoHeight || 200}px;
			object-fit: contain;
			margin: auto;
		}

		@media (max-width: 1280px) {
			display: none;
		}
	`,

	ResponsivePrizeDiv: styled.div`
		display: none;

		@media (max-width: 1280px) {
			display: flex;
			justify-content: space-between;
			gap: 32px;
			height: 19%;
			min-height: 19%;
			padding: 18px 40px;
			border-top: 2px solid
				${({$themeType, theme}) =>
					$themeType === BASIC ? '#000000' : '#ffffff'};
			z-index: 1;
		}
	`,

	PrizeListDiv: styled.div`
		flex-grow: 1;
		display: flex;
		flex-direction: column;
		gap: 8px;

		& > h2 {
			width: 100%;
			font-family: 'Pretendard';
			font-size: 24px;
			font-weight: 800;
			text-transform: uppercase;
			min-height: 32px;
			line-height: 1;
			color: ${({$themeType, theme}) =>
				$themeType === BASIC ? '#000000' : '#ffffff'};
		}
	`,

	PrizeList: styled.div`
		height: 100%;
		min-height: 0;
		overflow-y: auto;
		display: flex;
		flex-direction: column;
		gap: 8px;

		& > div {
			display: flex;
			justify-content: space-between;
			align-items: center;
			gap: 16px;

			& > p {
				font-family: 'Pretendard';
				font-size: 20px;
				line-height: 1.1;
				font-weight: 600;
				height: 22px;
				text-overflow: ellipsis;
				overflow: hidden;
				display: -webkit-box;
				-webkit-line-clamp: 1;
				-webkit-box-orient: vertical;
				color: ${({$themeType, theme}) =>
					$themeType === BASIC ? '#000000' : '#ffffff'};

				&:first-child {
					white-space: nowrap;
					overflow: visible;
				}
			}
		}

		@media (max-width: 1280px) {
			display: grid;
			grid-template-columns: 1fr 1fr;
			grid-template-rows: repeat(
				${({$itemCount}) => Math.ceil(($itemCount || 0) / 2)},
				min-content
			);
			grid-auto-flow: column;
			gap: 8px 16px;
			overflow-y: auto;

			& > div {
				display: flex;
				justify-content: space-between;
				align-items: center;
				gap: 8px;
			}
		}
	`,

	TotlePrizeDiv: styled.div`
		height: fit-content;
		display: flex;
		flex-direction: column;
		gap: 8px;

		& > h2 {
			width: 100%;
			font-family: 'Pretendard';
			font-size: 24px;
			font-weight: 800;
			text-transform: uppercase;
			height: 32px;
			line-height: 1;
			color: ${({$themeType, theme}) =>
				$themeType === BASIC ? '#000000' : '#ffffff'};
		}

		& > p {
			font-family: 'Pretendard';
			font-size: 20px;
			font-weight: 600;
			line-height: 28px;
			text-overflow: ellipsis;
			overflow: hidden;
			display: -webkit-box;
			-webkit-line-clamp: 4;
			-webkit-box-orient: vertical;
			color: ${({$themeType, theme}) =>
				$themeType === BASIC ? '#000000' : '#ffffff'};
		}
	`,

	ResponsiveLogoDiv: styled.div`
		display: none;

		@media (max-width: 1280px) {
			width: fit-content;
			display: flex;
			justify-content: center;
			align-items: center;

			& > img {
				width: 120px;
				height: 120px;
				object-fit: contain;
				margin: 0;
			}
		}
	`,
}

export default Style
